import { render, staticRenderFns } from "./AbsorptionScatteringThumbnail.vue?vue&type=template&id=d31e33d4&scoped=true&"
import script from "./AbsorptionScatteringThumbnail.vue?vue&type=script&lang=ts&"
export * from "./AbsorptionScatteringThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./AbsorptionScatteringThumbnail.vue?vue&type=style&index=0&id=d31e33d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31e33d4",
  null
  
)

export default component.exports